import React from 'react'

import { Card } from '@newComponents/Card'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocStep } from '../shared/DocStep'

const Embeds = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        User Embeds let you display your Guild profile on an external website.
        The embed widget shows your profile photo, display name, and a link to
        your full profile on Guild — perfect for personal websites, speaker
        pages, or team directories.
      </Paragraph>
      <Paragraph size='$5'>
        Like all Guild Embeds, user widgets load inside an iframe and are fully
        self-contained. They work on any website regardless of framework or CMS
        and automatically adapt to light and dark backgrounds.
      </Paragraph>
      {/* TODO: Capture screenshot of User profile → Share/Embed dialog showing the user embed code */}
    </Card>

    <Card gap='$4'>
      <DocSection id='getting-user-embed-code' title='Getting the Embed Code'>
        <Paragraph size='$5'>
          To embed your profile on an external site, follow these steps.
        </Paragraph>
        <DocStep
          number={1}
          title='Visit your profile page'
          description='Navigate to your profile by clicking your profile photo in the top-right corner and selecting your name, or by visiting your profile URL directly.'
        />
        <DocStep
          number={2}
          title='Open the share menu'
          description='Click the Share button on your profile page to see sharing options, including the embed code.'
        />
        <DocStep
          number={3}
          title='Copy the embed code'
          description='Copy the provided HTML snippet. It contains a script tag and a container element that renders the profile widget on your site.'
        />
        <DocStep
          number={4}
          title='Paste into your site'
          description='Add the embed code to any HTML page, blog, or CMS content block. The widget loads automatically and links back to your full profile on Guild.'
        />
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='user-embed-use-cases' title='When to Use User Embeds'>
        <Paragraph size='$5'>
          User Embeds are ideal for personal websites or portfolios where you want
          to link to your Guild profile, conference speaker pages where organizers
          list presenters, or company team pages that connect employees to their
          community profiles.
        </Paragraph>
        <Paragraph size='$5'>
          For embedding a Guild or its Events, see{' '}
          <Link href='/docs/guilds/embeds'>Guild Embeds</Link> and{' '}
          <Link href='/docs/events/embeds'>Event Embeds</Link>. For embedding
          individual Presentations, see{' '}
          <Link href='/docs/presentations/embeds'>Presentation Embeds</Link>.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Embeds
